export enum ITEM_KINDS {
  AUTO_INSURANCE = 'auto_insurance',
  DIY_MOVE = 'diy_move',
  DMV = 'dmv',
  FORWARD_MAIL = 'forward_mail',
  UPDATE_ACCOUNT = 'update_account',
  SHARE = 'share',
  HOME_SECURITY = 'home_security',
  HOME_SERVICE = 'home_service',
  HOME_SERVICES_APP = 'tv_internet',
  HUDSON_INSURANCE = 'hudson_insurance',
  INSURANCE = 'insurance',
  INSURANCE_QUOTE = 'insurance_quote',
  INSURANCE_RETENTION = 'insurance_retention',
  MOVEIQ = 'moveiq',
  MOVING_CENTER = 'moving_center',
  OFFER = 'offer',
  PROMOTION = 'promotion',
  RECOMMENDED_PROVIDER = 'recommended_provider',
  RED_CROSS = 'red_cross',
  RENTERS_INSURANCE = 'renters_insurance',
  RESIDENT_PORTAL = 'resident_portal',
  SMART_HOME_OWN = 'smart_home_own',
  UTILITY = 'utility',
  CALIFORNIA_CARE = 'california_care',
  BACKUP_GENERATOR = 'backup_generator',
  DUKE_WARRANTY = 'duke_warranty',
  DOLLY = 'dolly',
  MOVE_YOUR_STUFF = 'move_your_stuff',
  RELOCATION_SPECIALISTS = 'relocation_specialists',
  PACKING_SUPPLIES = 'packing_supplies',
  COMBINED_FSM_MYS = 'combined_fsm_mys',
  RESIDENT_ONBOARDING_INSURANCE = 'resident_onboarding-renters-insurance',
  RESIDENT_ONBOARDING_PET_REGISTRATION = 'resident_onboarding-pets',
  RESIDENT_ONBOARDING_VEHICLE_REGISTRATION = 'resident_onboarding-vehicles',
  RESIDENT_ONBOARDING_MOVE_IN_COSTS = 'resident_onboarding-move-costs',
}

export enum ITEM_STATUSES {
  ACTION_REQUIRED = 'action_required', // FE only, not an actual API status.
  ALREADY_DONE = 'already_done', // FE only, not an actual API status.
  CANCELLED = 'cancelled',
  COMPLETED = 'completed',
  CONFIRMED = 'confirmed',
  CLAIMED = 'claimed',
  NOT_NEEDED = 'not_needed', // FE only, not an actual API status.
  NOT_STARTED = 'not_started',
  PENDING = 'pending',
  RESERVED = 'reserved',
  STARTED = 'started',
  UNVERIFIED = 'unverified',
  VALIDATING = 'validating',
  CALLED = 'called',
  NEEDS_CONFIRMATION = 'needs_confirmation',
  INFO_REQUESTED = 'info_requested',
  VALIDATED_AND_COMPLETED = 'validated_and_completed', // FE only
}

export const TASK_APPROVED_MESSAGE =
  'The information you provided has been accepted by your leasing office. No further documentation is needed. If you have any questions, contact your leasing office.';
